/**
 * @generated SignedSource<<93b9137ecfa408fdf72a6735e84e32a3>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "DeleteScheduleShiftPayload",
            "kind": "LinkedField",
            "name": "deleteScheduleShift",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleShift",
                    "kind": "LinkedField",
                    "name": "shiftEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleShift",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DeleteScheduleShiftConfirmMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DeleteScheduleShiftConfirmMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "4870321fe996e91dce42c486401afd8c",
            "id": null,
            "metadata": {},
            "name": "DeleteScheduleShiftConfirmMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteScheduleShiftConfirmMutation(\n  $model: DeleteScheduleShiftRequestInput!\n) {\n  deleteScheduleShift(model: $model) {\n    shiftEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "8c668cc3f95621324709813bf9234f3a";
export default node;
